import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getAccountPayRuleDatatableAsync, resetSelectedRecordObjectInState, deleteAllSelectedRecordPayRuleAsync } from "./payRuleSlice";
import PayRuleForm from "./PayRuleForm";
import PayRuleItem from "./PayRuleItem";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import PayRuleOffCanvas from '../../../common/OffCanvas';
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from "../../../common/Toastr";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const PayCode = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { payRuleList, isReload, selectedRecord } = useAppSelector((state) => state.payRule);
    const { t } = useTranslation();
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    useEffect(() => {
        let stateItem: any = {}
        if (isReload) {
            dispatch(getAccountPayRuleDatatableAsync());
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAccountPayRuleDatatableAsync());
    }, [dispatch])

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };


    const filteredData = payRuleList.filter((item: any) => {
        const searchTermLowerCase = searchTerm.toLowerCase();
        return Object.values(item).some((value: any) => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchTermLowerCase);
            }
            return false;
        });
    });
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = payRuleList.length;
    const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];


    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedRecordPayRuleAsync(payRuleList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Pay Rule Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const generalObject = {
        "name": (Object.keys(selectedRecord).length > 0 ? t('Update Pay Rule') : t('Add Pay Rule')),
        "width": "800px",
        "componentName": <PayRuleForm t={t} />
    }


    return (
        <>
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold mainHeading">{t('Pay Rule')}</h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder={t('Search')}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            />
                        </div>


                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && payRuleList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsAdd &&
                            <a id="kt_OffCanvas"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                style={{ marginRight: '2px', display: payRuleList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                onClick={handleOnClickEvent}>
                                {t('Add Pay Rule')}
                            </a>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: payRuleList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{payRuleList.filter((item: any) => item.isSelected === 1).length}</span> {t('Selected')}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: payRuleList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {t('Delete')}
                                </button>
                            </>
                        }
                    </div>
                </div>
                <div className="card-body">

                    <div className="table-responsive">
                        <PayRuleItem payRuleList={currentItems} t={t} IsEdit={IsEdit} IsDelete={IsDelete} />
                    </div>
                </div>
            </div>

            <PayRuleOffCanvas obj={generalObject} />

        </>
    )
}

export default PayCode;

